import React from "react";

import { Tooltip } from "@material-ui/core";
import { green, orange } from "@material-ui/core/colors";

import { BlankIcon, ErrorFilledIcon, OKIcon } from "../../../components/common/iconography";

import { InventoryStatus } from "../../../utils/constants";

export const AuditStatusIcon = ({ record, ...props }) => {
  if (
    !record ||
    (record.status !== InventoryStatus.STORED &&
      record.status !== InventoryStatus.SHIPPED)
  )
    return <BlankIcon color="disabled" />;
  else
    return record.quantityMismatch ? (
      <Tooltip title="Failed Audit" placement="right" arrow>
        <ErrorFilledIcon style={{ color: orange[600] }} />
      </Tooltip>
    ) : (
      <Tooltip title="OK" placement="right" arrow>
        <OKIcon style={{ color: green[600] }} />
      </Tooltip>
    );
};
